<template>
  <div class="container-view">
    <Breadcrumbs />

    <div class="row col-12 container-titles" style="display: flex">
      <div class="header-title col-10">Aplicación {{ dataApp.name }}</div>
      <div class="col-2" style="padding-top: 24px; align-items: flex-end">
        <q-btn
          data-cy="save-app"
          style="width: 100%; margin-left: 0 !important"
          color="primary"
          label="Guardar"
          icon="save"
          @click="isNew ? emitNew() : emitgeneralSave()"
          :loading="isLoadingButton"
        />
      </div>
    </div>
    <div class="row col-12 full-height">
      <div class="col-8">
        <InformacionAplicacion
          :dataApp="dataApp"
          :isNew="isNew"
          :eventName="events.saveAplicacion"
          @changeType="changeType"
        />
      </div>
      <div class="col-4 right-container">
        <div class="servicio-container">
          <MultiSelect
            :labelBox="{
              title: 'Servicios que la utilizan',
              subtitle:
                (!isNew && isNew !== '' ? dataApp.name : 'La aplicación') +
                ' es utilizada por los siguientes servicios',
              select: 'Añadir servicio'
            }"
            labelDataCy="servicio-select"
            endPoint="Aplicacion"
            :dataObj="dataApp"
            relationShip="servicio-relationship"
            :arraySelected="dataApp.servicios"
            :arrayAll="arrayServicios"
            :eventName="events.saveServicios"
          />
        </div>
        <div class="rol-container" v-if="!isNew">
          <Roles :idApp="dataApp.id" />
        </div>
      </div>
    </div>
    <div class="row bottom-container">
      <div class="col-12" v-if="!isNew && !isApi">
        <Usuarios
          v-if="dataApp.id !== null"
          :dependecyApp="dataApp"
          :arrayUsuarios="arrayUsuarios"
          :requestUser="requestUser"
          :enableAuthorize="true"
          :showDeleteButton="true"
          :showRolSelector="true"
          :showEditButton="false"
          :showUsername="true"
          :showCompany="false"
          :showLocale="false"
          :title="'Usuarios'"
        />
      </div>
    </div>
    <div class="row bottom-container">
      <div class="col-12" v-if="!isNew && isSuperAdmin">
        <CuentasServicioList :dependecyApp="dataApp" />
      </div>
    </div>
    <div class="row bottom-container">
      <div class="col-12" v-if="!isNew && !isApi">
        <UsuariosDelivery
          v-if="dataApp.id !== null"
          :dependecyApp="dataApp"
          :arrayUsuarios="arrayUsuarios"
          :requestUser="requestUserDelivery"
          :enableAuthorize="true"
          :showDeleteButton="true"
          :showRolSelector="false"
          :showEditButton="false"
          :showUsername="true"
          :showCompany="false"
          :showLocale="false"
          :title="'Usuarios Delivery'"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';
import Loading from '@/components/shared/mixins/Loading.js';
import InformacionAplicacion from '../components/InformacionAplicacion.vue';
import Usuarios from '@/components/Usuarios/components/Listado.vue';
import MultiSelect from '@/shared/generic-multi-select/MultiSelect.vue';
import Roles from '../components/Roles.vue';
import CuentasServicioList from '../components/CuentasServicioList.vue';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import { mapGetters } from 'vuex';
import UsuariosDelivery from '@/components/Usuarios/components/ListadoUsuarioDelivery.vue';

export default {
  components: {
    InformacionAplicacion,
    Usuarios,
    MultiSelect,
    Roles,
    CuentasServicioList,
    Breadcrumbs,
    UsuariosDelivery
  },
  mixins: [Message, Validation, Loading],
  computed: {
    isApi () {
      return this.dataAppType === 1;
    },
    ...mapGetters({
      isAdmin: 'PF/isAdmin',
      isSuperAdmin: 'PF/isSuperAdmin'
    })
  },
  data: function () {
    return {
      dataApp: {
        id: null,
        servicios: []
      },
      dataAppType: null,
      arrayServicios: [],
      arrayUsuarios: [],
      isLoading: false,
      isNew: false,
      isLoadingButton: false,
      checkSave: {
        isInfoSave: null,
        isServiciosSave: null,
        existError: false
      },
      requestUser: {
        list: null,
        count: null,
        filter: null
      },
      requestUserDelivery: {
        list: null,
        count: null,
        filter: null
      },
      events: {
        saveAplicacion: 'APLICACION_ACTUALIZAR_INFORMACION',
        saveServicios: 'EJECUCION_GUARDAR_OPCIONES'
      }
    };
  },
  async created () {
    if (this.$route.params.idApp) {
      await this.getInfoApp();
    } else {
      this.isNew = true;
    }

    // General data
    await this.getServicios();
  },
  methods: {
    async emitNew () {
      // Reset variables
      this.resetSaved();

      this.$eventHub.$emit(this.events.saveAplicacion, {
        callback: x => {
          this.dataApp.id = x.data.id;
          this.checkSave.isInfoSave = x.status;

          this.$eventHub.$emit(this.events.saveServicios, {
            callback: x => {
              this.checkSave.isServiciosSave = x.status;
              this.checkSaved();
              this.isNew = false;

              this.setRequestUserParams(this.dataApp.id);
              this.setRequestUserDeliveryParams(this.dataApp.Id);

              // Change Page
              this.$router.push({
                name: 'form_application',
                params: { idApp: this.dataApp.id }
              });
            }
          });
        },
        rejected: x => {
          this.checkSave.isInfoSave = x.status;
          this.checkSaved();
        }
      });
    },
    async emitgeneralSave () {
      // Reset variables
      this.resetSaved();

      await this.$eventHub.$emit(this.events.saveAplicacion, {
        callback: x => {
          this.checkSave.isInfoSave = x.status;
          this.checkSaved();
        },
        rejected: x => {
          this.checkSave.isInfoSave = x.status;
          this.checkSaved();
        }
      });

      await this.$eventHub.$emit(this.events.saveServicios, {
        callback: x => {
          this.checkSave.isServiciosSave = x.status;
          this.checkSaved();
        }
      });
    },
    resetSaved () {
      this.isLoadingButton = true;
      this.checkSave.existError = false;
      this.checkSave.isInfoSave = null;
      this.checkSave.isServiciosSave = null;
    },
    checkSaved () {
      if (this.checkSave.isInfoSave && this.checkSave.isServiciosSave) {
        this.showMessage('Datos guardados con éxito.');
        // Stop Loading Button
        this.isLoadingButton = false;
      } else if (
        (this.checkSave.isInfoSave === false ||
          this.checkSave.isServiciosSave === false) &&
        this.checkSave.existError === false
      ) {
        this.checkSave.existError = true;
        this.showError('No se han podido guardar los datos.');
        // Stop Loading Button
        this.isLoadingButton = false;
      }
    },
    async getInfoApp (appId = null) {
      let idApp = appId === null ? this.$route.params.idApp : appId;

      this.showLoading();

      if (!idApp) {
        this.showError('No es una aplicación válida.');
        this.$router.push({ name: 'aplicaciones' });
      }

      this.setRequestUserParams(idApp);
      this.setRequestUserDeliveryParams(idApp);

      let request = {
        controller: '/Aplicacion/' + idApp
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(async response => {
          let data = response.data;
          data.id = idApp;
          this.dataApp = data;
          this.changeType(data.type);
          this.hideLoading();
        })
        .catch(err => {
          this.showError(err.message);
          this.hideLoading();
        });
    },
    async getServicios () {
      this.showLoading();
      let request = {
        controller: '/Servicio'
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(response => {
          this.arrayServicios = response.data;
          this.hideLoading();
        })
        .catch(err => {
          this.showError(err.message);
          this.hideLoading();
        });
    },
    setRequestUserParams (idApp) {
      // Set en una funcion aparte
      this.requestUser.list = `/Authorization/${idApp}`;
      this.requestUser.count = `/Authorization/${idApp}/Count`;
      this.requestUser.filter = `/Authorization/${idApp}/Search`;
    },
    setRequestUserDeliveryParams (idApp) {
      // Set en una funcion aparte
      this.requestUserDelivery.list = `/Authorization/DeliveryUser/${idApp}`;
      this.requestUserDelivery.count = `/Authorization/DeliveryUser/${idApp}/Count`;
      this.requestUserDelivery.filter = `/Authorization/DeliveryUser/${idApp}/Search`;
    },
    changeType (type) {
      this.dataAppType = type;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/css/style.scss";
.right-container {
  padding-left: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.rol-container {
  padding-top: 27px;
}

.bottom-container {
  padding-top: 32px;
}
</style>
